function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M49.7916 21.1635L39.7916 11.1635L29.7916 21.1635C32.3383 23.7402 35.8916 25.3135 39.7916 25.3135C43.6916 25.3135 47.2449 23.7402 49.7916 21.1635ZM63.3383 34.6868L56.2449 27.6368C51.8716 32.0402 46.0283 34.4635 39.7916 34.4635C33.5549 34.4635 27.7116 32.0402 23.3383 27.6368L16.2449 34.6868C22.5083 40.9902 30.8716 44.4635 39.7916 44.4635C48.7116 44.4635 57.0749 40.9902 63.3383 34.6868ZM2.91495 48.0235L9.99828 40.9668C17.945 48.9402 28.5249 53.3335 39.7916 53.3335C51.0583 53.3335 61.6383 48.9402 69.5816 40.9668L76.6683 48.0235C66.8316 57.8968 53.7383 63.3335 39.7916 63.3335C25.8449 63.3335 12.7516 57.8968 2.91495 48.0235Z",
  fill: "white"
});

function SvgWifi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi);
export default __webpack_public_path__ + "static/media/wifi.f35365ed.svg";
export { ForwardRef as ReactComponent };